import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter, forwardRef } from '@angular/core';
import { 
    ToastController, AlertController
} from '@ionic/angular/standalone';
import { FormGroup, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { DemoozDateToStringPipe } from '@demooz/pipes';
import { DemoozButtonComponent, DemoozTextareaComponent } from '@demooz/components';
import { QuestionService, AmbassadorService } from '@app/services';
import { Question } from '@app/models';

@Component({
    selector: 'app-questions-answer',
    templateUrl: './answer.component.html',
    styleUrls: ['./answer.component.scss'],
    imports: [
        TranslatePipe, DemoozDateToStringPipe, ReactiveFormsModule, 
        forwardRef(() => DemoozButtonComponent), forwardRef(() => DemoozTextareaComponent)
    ]
})
export class QuestionsAnswerComponent  implements OnInit {
      
    @Input({alias : 'question', required : true}) question: Question;
    @Output() onSendAnswerQuestion = new EventEmitter<boolean>();
    
    isFetchingAnswer: boolean= false;
    testerName: string = '';
    dateCreation: Date;
    answerForm: FormGroup = new FormGroup({
        answer: new FormControl(null, Validators.required),       
    });
      
    constructor(    
        public translateService: TranslateService,
        private toastController: ToastController,
        private alertController: AlertController,
        public questionService: QuestionService,
        public ambassadorService: AmbassadorService
    ) { }

    ngOnInit() {
        
    }
    
    async ngOnChanges(changes: SimpleChanges) {
        if(changes['question'] && changes['question'].currentValue){
            this.initQuestion();
        }
    }
    
    initQuestion(){
        this.testerName = this.question.tester?.firstName+' '+this.question.tester?.lastName.charAt(0)+'.';        
        this.dateCreation = new Date(parseInt(this.question._.created));        
    }
    
    async confirmSendAnswer(){
        if(this.answerForm.valid){   
            const alert = await this.alertController.create({
                message: this.translateService.instant('QUESTION_ANSWER.MSG_CONFIRM_SEND_ANSWER'),
                buttons: [{
                        text: this.translateService.instant('MAIN.CANCEL'),
                        role: 'cancel'
                    },
                    {
                        text: this.translateService.instant('MAIN.VALIDATE'),
                        role: 'confirm',
                        handler: () => {                        
                            this.sendAnswer();                        
                        }
                    }                    
                ],
            })
            await alert.present();    
        }
        else{
            for (var controlName in this.answerForm.controls) {
                if(!this.answerForm.controls[controlName].valid) {
                    this.answerForm.controls[controlName].markAsTouched();
                }
            }
        }    
    }
     
    async sendAnswer() {        
        this.isFetchingAnswer = true;
        let status = await this.questionService.sendAnswer(this.question.ID, this.answerForm.controls['answer'].value);  
        this.isFetchingAnswer = false;                 
        if(status){            
            const toast = await this.toastController.create({
                message: this.translateService.instant('QUESTION_ANSWER.MSG_SUCCESS_SEND_ANSWER'),
                duration: 6000,
                position: 'top',
                color: 'success'
            });
            await toast.present();   
            await this.ambassadorService.refreshAmbassador();  
            this.answerForm.reset();   
            this.onSendAnswerQuestion.emit(true);
        }
        else{               
            const toast = await this.toastController.create({
                message: this.translateService.instant('QUESTION_ANSWER.MSG_ERROR_SEND_ANSWER'),
                duration: 6000,
                position: 'top',
                color: 'danger'
            });
            await toast.present();
        } 
    }
    
}
